import { render } from "./CardProyectComponent.vue?vue&type=template&id=3dce9532&class=card-proyect-component"
import script from "./CardProyectComponent.vue?vue&type=script&lang=js"
export * from "./CardProyectComponent.vue?vue&type=script&lang=js"

import "./CardProyectComponent.vue?vue&type=style&index=0&id=3dce9532&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__